export default "__VITE_ASSET__B9XlSP8t__"